import "./index.scss";
import { Link } from "gatsby";
import React from "react";

interface Props {
  abstract?: string;
  link: string;
  title?: string;
  index: string | number;
}

const SearchItem = ({ link, title, abstract, index }: Props) => {
  return (
    <div className="search-item" data-testid={`hit-${index}`}>
      <div className="search-item__content">
        <Link to={link} className="search-item__link">
          <span className="search-item__title">{title}</span>
          <p className="search-item__abstract">{abstract}</p>
        </Link>
      </div>
    </div>
  );
};

export default SearchItem;
